import React from "react";

const SkillsAnimation = () => {
  return (
    <div>
      <img
        src="https://git-scm.com/images/logos/downloads/Git-Icon-1788C.png"
        className="hero__rocket_1"
        alt="starts"
      />
      <img
        src="https://cdn-icons-png.flaticon.com/512/732/732212.png"
        className="hero__rocket_2"
        alt="starts"
      />
      <img
        src="https://camo.githubusercontent.com/119b29ca4b9d31cf3969a94eb57fcfbbea0879b493c09c89dc6d4b7fb9e0dc37/68747470733a2f2f63646e2e776f726c64766563746f726c6f676f2e636f6d2f6c6f676f732f6373732d332e737667"
        className="hero__rocket_3"
        alt="starts"
      />
      <img
        src="https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/Tailwind_CSS_Logo.svg/2048px-Tailwind_CSS_Logo.svg.png"
        className="hero__rocket_5"
        alt="starts"
      />
      <img
        src="https://cdn-icons-png.flaticon.com/512/1260/1260667.png"
        className="hero__rocket_6"
        alt="starts"
      />
      <img
        src="https://camo.githubusercontent.com/119b29ca4b9d31cf3969a94eb57fcfbbea0879b493c09c89dc6d4b7fb9e0dc37/68747470733a2f2f63646e2e776f726c64766563746f726c6f676f2e636f6d2f6c6f676f732f6373732d332e737667"
        className="hero__rocket_3"
        alt="starts"
      />
      <img
        src="https://upload.wikimedia.org/wikipedia/commons/thumb/b/b2/Bootstrap_logo.svg/1200px-Bootstrap_logo.svg.png"
        className="hero__rocket_7"
        alt="starts"
      />
      <img
        src="https://upload.wikimedia.org/wikipedia/commons/3/33/Figma-logo.svg"
        className="hero__rocket_8"
        alt=""
      />
      <img
        src="https://www.wizcase.com/wp-content/uploads/2020/12/IndESIGN-LOGO.png"
        className="hero__rocket_9"
        alt=""
      />
    </div>
  );
};

export default SkillsAnimation;
